/**
 * PAGE D'ACCUEIL — SÉQUENCE D'ENTRÉE
 *
 * Les états initiaux sont posés en CSS sous html.anim_accueil (voir accueil.scss
 * et le script inline de header-accueil.php), pour qu'aucun flash du rendu final
 * n'apparaisse avant l'exécution du JS. La classe est retirée en fin de séquence.
 *
 * min.js étant chargé sur l'ensemble du site, ce fichier sort immédiatement
 * lorsqu'il n'est pas sur la page d'accueil.
 */
jQuery(document).ready(function ($) {

    const page = document.querySelector(".page_accueil")

    if (!page)
        return

    const html = document.documentElement

    // animations réduites : on lève les états initiaux sans rien jouer
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        html.classList.remove("anim_accueil")
        return
    }

    const TEMPO = 1.4               // tempo global de la séquence
    const RESPIRE_ZOOM = 1.06       // zoom atteint par le fond pendant sa respiration
    const RESPIRE_DUREE = 22        // secondes d'un aller de la respiration

    const fond = page.querySelector(".background")
    const fondImage = page.querySelector(".background img")
    const carte = page.querySelector(".carte")
    const logo = page.querySelector(".logo")
    const titre = page.querySelector("h1")
    const accroche = page.querySelector(".accroche")
    const boutons = gsap.utils.toArray(page.querySelectorAll(".liens .bouton"))
    const texte = page.querySelector(".texte")

    /**
     * Le titre est découpé en mots pour les faire monter un à un. Le h1 lui-même
     * est masqué par le CSS : on le révèle d'un bloc, ce sont ses mots qui portent
     * l'animation.
     */
    let mots = []

    if (titre) {
        mots = new SplitText(titre, { type: "words", wordsClass: "word" }).words
        gsap.set(mots, { display: "inline-block" })
        gsap.set(titre, { opacity: 1 })
    }

    const tl = gsap.timeline({
        defaults: { ease: "power3.out", force3D: true },
        onComplete: function () {
            html.classList.remove("anim_accueil")
        }
    })

    tl.timeScale(TEMPO)

    // 1 — le fond s'ouvre en Ken Burns. Le zoom porte sur l'image et non sur son
    // cadre : le cadre est en position fixed, l'agrandir le ferait déborder de l'écran.
    if (fond)
        tl.fromTo(fond, { opacity: 0 }, { opacity: 1, duration: 1.8, ease: "power2.out" }, 0)

    if (fondImage)
        tl.fromTo(fondImage, { scale: 1.18 }, { scale: 1, duration: 1.8, ease: "power2.out" }, 0)

    // 2 — la carte se pose
    if (carte)
        tl.fromTo(carte,
            { opacity: 0, y: 70, scale: .96 },
            { opacity: 1, y: 0, scale: 1, duration: 1.1, ease: "power4.out" },
            .45)

    // 3 — le logo, du flou vers le net
    if (logo)
        tl.fromTo(logo,
            { opacity: 0, scale: 1.14, filter: "blur(14px)" },
            { opacity: 1, scale: 1, filter: "blur(0px)", duration: .9 },
            .85)

    // 4 — le titre, mot à mot. Simple montée en fondu : une bascule en rotationX
    // déformait trop les mots au départ de la séquence.
    if (mots.length)
        tl.fromTo(mots,
            { opacity: 0, yPercent: 40 },
            { opacity: 1, yPercent: 0, duration: .7, stagger: .06 },
            1.3)

    // 5 — l'accroche
    if (accroche)
        tl.fromTo(accroche,
            { opacity: 0, y: 16 },
            { opacity: 1, y: 0, duration: .6 },
            1.65)

    // 6 — les boutons
    if (boutons.length)
        tl.fromTo(boutons,
            { opacity: 0, y: 28, scale: .88 },
            { opacity: 1, y: 0, scale: 1, duration: .6, stagger: .14, ease: "back.out(1.7)" },
            1.85)

    // 7 — le texte
    if (texte)
        tl.fromTo(texte,
            { opacity: 0, y: 12 },
            { opacity: 1, y: 0, duration: .6 },
            2.2)

    /**
     * Une fois l'entrée jouée, le fond respire, très lentement. Le zoom d'entrée
     * étant terminé, plus personne d'autre n'écrit scale sur cette image.
     */
    if (fondImage)
        tl.add(function () {
            gsap.to(fondImage, {
                scale: RESPIRE_ZOOM,
                xPercent: -1.5,
                duration: RESPIRE_DUREE,
                ease: "sine.inOut",
                yoyo: true,
                repeat: -1
            })
        })

})
